import { Button } from "@/components/ui/button";
import { AuthForm } from "@/components/auth/AuthForm";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export const AuthScreen = () => {
  const [isLogin, setIsLogin] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_IN') {
        navigate('/workspace');
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-background animate-fade-in">
      <div className="text-center mb-8 animate-fade-in">
        <img 
          src="/lovable-uploads/d8edf8a7-daeb-4805-8270-304464f41613.png" 
          alt="MindTube" 
          className="mindtube-logo mx-auto mb-2"
        />
        <p className="text-gray-400">
          Transform how you engage with YouTube videos
        </p>
      </div>
      <div className="w-full max-w-sm animate-scale-in">
        <AuthForm isLogin={isLogin} />
        <div className="mt-4 text-sm text-gray-400 text-center">
          {isLogin ? "Don't have an account? " : "Already have an account? "}
          <Button
            variant="link"
            className="text-primary p-0 h-auto"
            onClick={() => setIsLogin(!isLogin)}
          >
            {isLogin ? "Sign Up" : "Sign In"}
          </Button>
        </div>
      </div>
    </div>
  );
};